import React from "react";
import {
  NewTab,
  PageHeader,
  PageTab,
  PageTabAdv,
  PageTitle,
} from "../../../components";

import AllInvoices from "./Invoices/AllInvoices";
import DueInvoices from "./Invoices/DueInvoices";
import PaidInvoices from "./Invoices/PaidInvoices";
import OpenInvoices from "./Invoices/OpenInvoices";
import ClientRejectedInvoices from "./Invoices/ClientRejectedInvoices";
import ApprovalFlow from "./Invoices/ApprovalFlow";
import InvoiceDashboard from "./Invoices/InvoiceDashboard";

const Invoices = () => {
  const InvoiceMenus = [
    {
      title: "Accounts Receivables",
      page: <InvoiceDashboard />,
      type: "main",
    },
    {
      title: "All Invoices",
      page: <AllInvoices />,
      type: "main",
    },
    {
      title: "Due Invoices",
      page: <DueInvoices />,
      type: "main",
    },
    {
      title: "Paid Invoices",
      page: <PaidInvoices />,
      type: "main",
    },
    {
      title: "Open Invoices",
      page: <OpenInvoices />,
      type: "main",
    },
    // {
    //   title: "Client Rejected Invoices",
    //   page: <ClientRejectedInvoices />,
    //   type: "main",
    // },
    // {
    //   title: "Approval Flow",
    //   page: <ApprovalFlow />,
    //   type: "main",
    // },
    {
      title: "Add Invoices",
      link: "/invoices/add-invoices",
      type: "sub",
      icon: "add",
    },
    {
      title: "Quickbooks Integration",
      link: "/quickbooks",
      type: "sub",
      icon: "newsstand",
    },
    // {
    //   title: "Create Bulk Invoices",
    //   link: "/invoices/bulk-invoices",
    //   type: "sub",
    //   icon: "add",
    // },
  ];

  return (
    <div className="flex-1 flex flex-col w-full h-full overflow-hidden">
      <PageHeader
        Section={
          <div className="flex my-3">
            <PageTitle title={"Invoice Management"} tag="h5" />
          </div>
        }
      />
      <NewTab
        tabs={InvoiceMenus}
        color="black"
        variant="outlined"
        tabLevel="employees"
        // mainTabsShow={4}
        mode="url"
        tabId="invoices"
      />
    </div>
  );
};

export default Invoices;
